var React = require('react');

function IconNewsSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.1 66.1c-8.9 0-16 7.1-16 16.1L64.6 959 255 767.6h690.5c8.8 0 16-7.2 16-16V82.1c0-8.8-7.2-16-16-16H81.1zm297.4 399.6h-89.7V376h89.7v89.7zm179.3 0h-89.7V376h89.7v89.7zm179.4 0h-89.7V376h89.7v89.7z"}));
}

IconNewsSolid.displayName = "IconNewsSolid";

IconNewsSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconNewsSolid;

IconNewsSolid.default = IconNewsSolid;
